// import { take, call, put, select, takeLatest } from 'redux-saga/effects';
// import { notificationsActions as actions } from '.';

// function* doSomething() {}

export function* notificationsSaga() {
    // yield takeLatest(actions.someAction.type, doSomething);
}
